const { jQuery: $ } = window;
import config from '../../settings.json';
import Theme from './modules/theme.class';
import Utils from "./modules/utils.class";

require("./lib/jquery.cycle2");

const utils = new Utils();
const theme = new Theme(
    config,
    utils
);

$(() => theme.__onReady());
$(window).on('load', () => theme.__onLoad());
$(window).on('resize', () => theme.__onResize());

window.Theme = theme;